import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appEmailMobile]'
})
export class EmailMobileDirective {

  constructor(private el: ElementRef<HTMLInputElement>) { }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    // Allow only alphabets, numbers, spaces, @, _, and .
    const sanitizedValue = value.replace(/[^a-zA-Z0-9@_\.\s]/g, '');

    // Check if the input starts with restricted digits (0-5) for mobile numbers
    let newValue = sanitizedValue;
    if (sanitizedValue.length > 0 && /^[0-5]/.test(sanitizedValue)) {
      // Remove the restricted digit if found at the beginning
      newValue = sanitizedValue.replace(/^[0-5]/, '');
    }

    // Update the value only if it has changed
    if (this.el.nativeElement.value !== newValue) {
      this.el.nativeElement.value = newValue;
      // Dispatch input event to notify Angular about the value change
      this.el.nativeElement.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }


}
